import { ModalContentStrategy } from "./ModalContentStrategy";

export interface ModalElement {
  displayText?: string;
  isEmptyLine?: boolean;
  isStartList?: boolean;
  isEndList?: boolean;
  isStartItem?: boolean;
  isEndItem?: boolean;
  shouldDisplayBolded?: boolean;
  beforeText?: string;
  afterText?: string;
}

export interface MessageContent {
  updates: ModalElement[];
  invoice: ModalElement[];
  info: ModalElement[];
}

export class ModalContentContext {
  private contentBuilder: ModalContentStrategy;

  constructor(contentBuilder: ModalContentStrategy) {
    this.contentBuilder = contentBuilder;
  }

  getModalContent(): MessageContent {
    const { updates, invoice, info } = this.contentBuilder.buildModalContent();

    return { updates: updates, invoice: invoice, info: info };
  }
}
